import DisablableHeaderActionButton from './DisablableHeaderActionButton'
import { useCheckPermissions } from 'hooks/useCheckPermission'
import { useCIMSTableContext } from '../../../CIMSTableContext'

function CreateHeaderActionButton<T extends object>() {
  const {
    dataSource,
    actions,
    modals: { simpleCreate },
  } = useCIMSTableContext<T>()
  const { entity, modal, permission, ...rest } = actions.header.create ?? {}
  const canCreate = useCheckPermissions(dataSource)
  const title = `Create ${entity}`
  if (!canCreate(permission)) return null
  return (
    <DisablableHeaderActionButton
      {...rest}
      type="primary"
      callback={() => {
        if (modal?.type === 'custom') return modal.toggle(null)
        return simpleCreate.toggle(null)
      }}
    >
      {title}
    </DisablableHeaderActionButton>
  )
}
export default CreateHeaderActionButton
